(function($) {
  "use strict";
  // $(window).on('load', function() {
  //   $('.preloader').delay('500').fadeOut(2000);
  // });
  $(document).ready(function() {
    $(document).on("click", ".menu-toggler", function() {
      $(this).toggleClass('active');
      $(".main-menu").slideToggle(200);
    });
    var dropdowmMenu = $('.main-menu .dropdown-menu-item, .menu-category .sub-menu');
    dropdowmMenu.parent('li').children('a').append(function() {
      return '<button class="sub-nav-toggler" type="button"><i class="la la-angle-down"></i></button>';
    });
    var dropMenuToggler = $('.main-menu .sub-nav-toggler, .menu-category .sub-nav-toggler');
    dropMenuToggler.on('click', function() {
      var Self = $(this);
      Self.parent().parent().children('.dropdown-menu-item, .sub-menu').fadeToggle();
      return false;
    });
    var isMenuOpen = false;
    $(window).on('resize', function() {
      if ($(window).width() > 991) {
        $('.main-menu').show();
        $('.dropdown-menu-item').show();
        $('.sub-menu').show();
      } else {
        if (isMenuOpen) {
          $('.main-menu').show();
          $('.dropdown-menu-item').show();
          $('.sub-menu').show();
        } else {
          $('.main-menu').hide();
          $('.dropdown-menu-item').hide();
          $('.sub-menu').hide();
        }
      }
    });
    var scrollButton = $('#scroll-top');
    var nav = document.querySelector('.header-menu-content');
    if (nav) {
      var topOfNav = nav.offsetTop;
    }
    $(window).on('scroll', function() {
      if ($(window).scrollTop() >= topOfNav) {
        document.body.style.paddingTop = nav.offsetHeight + 'px';
        document.body.classList.add('fixed-nav');
      } else {
        document.body.style.paddingTop = '0px';
        document.body.classList.remove('fixed-nav');
      }
      if ($(this).scrollTop() >= 300) {
        scrollButton.show();
      } else {
        scrollButton.hide();
      }
      var my_skill = '.skills .skill';
      if ($(my_skill).length !== 0) {
        spy_scroll(my_skill);
      }
    });
    $(document).on('click', '#scroll-top', function() {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
    });
    $(document).on('click', '.side-menu-open', function() {
      $('.user-nav-container').addClass('active');
    });
    $(document).on('click', '.dashboard-nav-trigger-btn', function() {
      $('.dashboard-nav-container').addClass('active');
    });
    $(document).on('click', '.humburger-menu .side-menu-close', function() {
      $('.side-nav-container, .user-nav-container, .dashboard-nav-container').removeClass('active');
    });
    // $('.hero-slide').owlCarousel({
    //   items: 1,
    //   nav: true,
    //   dots: true,
    //   autoplay: false,
    //   loop: true,
    //   smartSpeed: 6000,
    //   animateOut: 'slideOutRight',
    //   animateIn: 'fadeIn',
    //   active: true,
    //   navText: ["<i class='la la-angle-left'></i>", "<i class='la la-angle-right'></i>"],
    // });
    // $('.course-carousel').owlCarousel({
    //   loop: true,
    //   items: 3,
    //   nav: true,
    //   dots: false,
    //   smartSpeed: 500,
    //   autoplay: false,
    //   margin: 30,
    //   navText: ["<i class='la la-angle-left'></i>", "<i class='la la-angle-right'></i>"],
    //   responsive: {
    //     320: {
    //       items: 1,
    //     },
    //     992: {
    //       items: 3,
    //     }
    //   }
    // });
    // $('.view-more-carousel').owlCarousel({
    //   loop: true,
    //   items: 2,
    //   nav: false,
    //   dots: true,
    //   smartSpeed: 500,
    //   autoplay: true,
    //   margin: 15,
    //   responsive: {
    //     320: {
    //       items: 1,
    //     },
    //     768: {
    //       items: 2,
    //     }
    //   }
    // });
    // $('.view-more-carousel-2').owlCarousel({
    //   loop: true,
    //   items: 3,
    //   nav: false,
    //   dots: true,
    //   smartSpeed: 500,
    //   autoplay: true,
    //   margin: 15,
    //   responsive: {
    //     320: {
    //       items: 1,
    //     },
    //     768: {
    //       items: 3,
    //     }
    //   }
    // });
    // $('.testimonial-carousel').owlCarousel({
    //   loop: true,
    //   items: 5,
    //   nav: false,
    //   dots: true,
    //   smartSpeed: 500,
    //   autoplay: false,
    //   margin: 30,
    //   autoHeight: true,
    //   responsive: {
    //     320: {
    //       items: 1,
    //     },
    //     767: {
    //       items: 2,
    //     },
    //     992: {
    //       items: 3,
    //     },
    //     1025: {
    //       items: 4,
    //     },
    //     1440: {
    //       items: 5,
    //     }
    //   }
    // });
    // $('.testimonial-carousel-2').owlCarousel({
    //   loop: true,
    //   items: 2,
    //   nav: true,
    //   dots: false,
    //   smartSpeed: 500,
    //   autoplay: false,
    //   margin: 30,
    //   autoHeight: true,
    //   navText: ["<i class='la la-angle-left'></i>", "<i class='la la-angle-right'></i>"],
    //   responsive: {
    //     320: {
    //       items: 1,
    //     },
    //     768: {
    //       items: 2
    //     }
    //   }
    // });
    
    $('.faq-body > .faq-panel.is-active').children('.faq-content').show();
    $('.faq-body > .faq-panel').on('click', function() {
      $(this).siblings('.faq-panel').removeClass('is-active').children('.faq-content').slideUp(200);
      $(this).toggleClass('is-active').children('.faq-content').slideToggle(200);
    });

    // if ($('.datepicker').length) {
    //   $('.datepicker').dateTimePicker({
    //     format: 'dd/MM/yyyy'
    //   });
    // }
    $('.course-list > .course-item-link').on('click', function() {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
      if ($(this).is('.active-resource')) {
        $('.lecture-viewer-text-wrap').addClass('active');
      } else if ($(this).not('.active-resource')) {
        $('.lecture-viewer-text-wrap').removeClass('active');
      }
    });
    $(document).on('click', '.sidebar-close', function() {
      $('.course-dashboard-sidebar-column, .course-dashboard-column, .sidebar-open').addClass('active');
    });
    $(document).on('click', '.sidebar-open', function() {
      $('.course-dashboard-sidebar-column, .course-dashboard-column, .sidebar-open').removeClass('active');
    });
    $(document).on('click', '.ask-new-question-btn', function() {
      $('.new-question-wrap, .question-overview-result-wrap').addClass('active');
    });
    $(document).on('click', '.question-meta-content, .question-replay-btn', function() {
      $('.replay-question-wrap, .question-overview-result-wrap').addClass('active');
    });
    $(document).on('click', '.back-to-question-btn', function() {
      $('.new-question-wrap, .question-overview-result-wrap, .replay-question-wrap').removeClass('active');
    });
    $(document).on('click', '.swapping-btn', function() {
      $(this).siblings('.bookmark-icon').toggleClass('active');
      var el = $(this);
      el.text() == el.data('text-swap') ? el.text(el.data('text-original')) : el.text(el.data('text-swap'));
    });
    $(document).on('click', '.search-form-btn', function() {
      $('.search-course-form').toggleClass('active');
    });
    $(document).on('click', '.search-close-icon', function() {
      $('.search-course-form').removeClass('active');
    });
    $(document).on('click', '.collection-link', function() {
      $(this).children('.collection-icon').toggleClass('active');
    });
    // $('.sort-ordering-select').selectpicker({
    //   liveSearch: true,
    //   liveSearchPlaceholder: 'Search',
    //   liveSearchStyle: 'contains',
    //   size: 5
    // });
    // $('#teamModal').on('show.bs.modal', function(event) {
    //   var button = $(event.relatedTarget);
    //   var recipient = button.data('whatever');
    //   var modal = $(this);
    //   modal.find('.modal-title').text(recipient + '\'s Bio');
    // });
  });
})(jQuery);